import { Component, inject, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { skip } from 'rxjs';
import { NxSpinnerModule } from '@allianz/ng-aquila/spinner';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { BankTransferInstructions, PaymentCardComponent, PaymentPublic } from '@gsa/payment-card';
import { ErrorService } from '../../services/error.service';
import { ErrorComponent } from "../error/error.component";
import { NotFoundComponent } from "../not-found/not-found.component";
import { PaymentBankTransferComponent } from '../payment-bank-transfer/payment-bank-transfer.component';
import { PaymentErrorComponent } from "../payment-error/payment-error.component";
import { PaymentVerificationComponent } from "../payment-verification/payment-verification.component";

@Component({
  selector: 'app-payment',
  imports: [
    NxSpinnerModule,
    NotFoundComponent,
    PaymentCardComponent,
    PaymentVerificationComponent,
    PaymentErrorComponent,
    TranslocoPipe,
    PaymentBankTransferComponent,
    ErrorComponent,
  ],
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss'
})
export class PaymentComponent {
  errorService = inject(ErrorService);
  private readonly route = inject(ActivatedRoute);
  private readonly translocoService = inject(TranslocoService);
  private readonly paymentCard = viewChild(PaymentCardComponent);
  paymentId = (this.route.snapshot.params['paymentId'] ?? this.route.snapshot.params['paymendId']) as string;

  paymentData: PaymentPublic | null = null;
  paymentResult: boolean | null = null;
  bankTransferInstructions: BankTransferInstructions | null = null;

  constructor() {
    this.translocoService.langChanges$.pipe(skip(1), takeUntilDestroyed()).subscribe((lang) => {
      this.paymentCard()?.updateLocale(lang).catch((error: unknown) => console.error('Error updating payment form locale:', error));
    });
  }

  handlePaymentData(data: PaymentPublic) {
    this.paymentData = data;
  }

  handlePaymentResult(result: boolean | null = null) {
    this.paymentResult = result;
  }

  handleBankTransferInstructions(result: BankTransferInstructions | null = null) {
    this.bankTransferInstructions = result;
  }

  handlePaymentError(error: unknown) {
    if (error instanceof HttpErrorResponse) {
      this.errorService.error.set(error);
    }
  }
}
